import {Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild, OnChanges} from '@angular/core';
import {Address} from 'src/app/shared';

declare let google: any;

@Component({
  selector: 'app-address-auto-complete',
  templateUrl: './address-auto-complete.component.html',
  styleUrls: ['./address-auto-complete.component.scss']
})
export class AddressAutoCompleteComponent implements OnChanges {
  @Input() placeholder = 'Enter your address';
  @Input() initValue: string = '';
  @Input() cssClass: string;
  @Input() clearField = false;
  @Input() required = false;
  @Input() formControlName?: string;
  @Output() onPlaceChanged: EventEmitter<Address> = new EventEmitter<Address>();
  @Output() onChanges: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild('autocompleteInput', {static: true}) autocompleteInput: ElementRef;

  autocomplete;

  constructor() {
  }

  ngOnChanges() {
    if (this.initValue) {
      this.autocompleteInput.nativeElement.value = this.initValue;
    }
  }

  // Bias the autocomplete object to the user's geographical location,
  // as supplied by the browser's 'navigator.geolocation' object.
  geolocate(event: FocusEvent) {
    if (this.autocomplete == null) {
      if (event.srcElement != null) {
        this.autocomplete = new google.maps.places.Autocomplete(event.srcElement, {types: ['geocode']});
      } else {
        this.autocomplete = new google.maps.places.Autocomplete(event.target, {types: ['geocode']});
      }
      this.autocomplete.addListener('place_changed', () => {
        this.fillInAddress();
      });
    }
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const geolocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        const circle = new google.maps.Circle({
          center: geolocation,
          radius: position.coords.accuracy
        });
        this.autocomplete.setBounds(circle.getBounds());
      });
    }
  }

  onInputChanges() {
    this.onChanges.emit(this.autocompleteInput.nativeElement.value);
  }

  fillInAddress() {
    const place = this.autocomplete.getPlace();
    if (place.geometry) {
      const address = {
        street: '',
        city: '',
        state: '',
        zipcode: '',
        country: '',
        county: '',
        address_type: '',
        latitude: place.geometry.location.lat(),
        longitude: place.geometry.location.lng()
      } as Address;
      for (const addressComponent of place.address_components) {
        const types = addressComponent.types as string[];
        if (types.findIndex(r => 'street_number' === r) >= 0) {
          address.street = address.street ? addressComponent.long_name + ' ' + address.street : addressComponent.long_name;
        } else if (types.findIndex(r => 'route' === r) >= 0) {
          address.street = address.street ? address.street + ' ' + addressComponent.short_name : addressComponent.short_name;
        } else if (types.findIndex(r => 'locality' === r) >= 0) {
          address.city = addressComponent.long_name;
        } else if (types.findIndex(r => 'administrative_area_level_2' === r) >= 0) {
          address.county = addressComponent.long_name;
        } else if (types.findIndex(r => 'administrative_area_level_1' === r) >= 0) {
          address.state = addressComponent.long_name;
        } else if (types.findIndex(r => 'country' === r) >= 0) {
          address.country = addressComponent.long_name;
        } else if (types.findIndex(r => 'postal_code' === r) >= 0) {
          address.zipcode = addressComponent.long_name;
        }
      }
      this.autocompleteInput.nativeElement.value = address.street;
      this.onPlaceChanged.emit(address);
      if (this.clearField) {
        this.autocompleteInput.nativeElement.value = '';
        this.autocompleteInput.nativeElement.blur();
      }
    }
  }
}
